import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import { userEmailHydrator } from '../../fieldOptions/hydrators'

const columns = [
  { title: 'User', prop: 'member_id', references: 'admin/users', referenceProp: 'name' },
  { title: 'Plan', prop: 'membership_plan_id', references: 'admin/membership_plans', referenceProp: 'name' },
  { title: 'Expiry', prop: 'expires_at', format: 'fromNow' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by user', prop: 'filters.member_id', type: 'autocomplete', references: 'admin/users', dataHydrator: userEmailHydrator, displayProp: 'displayVal', referenceProp: 'fullname', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }],
  filters: {
    member_type: 'user'
  }
}

const UserMemberships = props => (
  <List
    title='Individual Memberships'
    apiPath='admin/memberships'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default UserMemberships
